export const availabilityStatusMap: Record<string, string> = {
  "0": "Trenutno nije raspoloživo.",
  "10": "Raspoloživo odmah!",
  "100": "Raspoloživo odmah!",
  "70": "Raspoloživo odmah!",
  "60": "Raspoloživo odmah!",
  "20": "Raspoloživo uz narudžbu.",
  "30": "Trenutno nije raspoloživo.",
  "40": "U dolasku!",
  "50": "Na upit.",
};

export const markerMap: Record<string, string> = {
  15: "Best Price",
  14: "Akcija",
  9: "Best Price",
  17: "Outlet",
  2: "Novo",
  8: "Prednarudžba",
};
